<template lang="pug">
  v-snackbar(v-model="show" left :multi-line="multiLine") {{ message }}
    v-btn.bold(flat color="purple lighten-2" @click.native="show = false") {{ $tf('snackbar.close') }}
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Snackbar',

  data() {
    return {
      show: false,
      multiLine: false,
      message: '',
    }
  },

  created() {
    this.$store.watch(state => state.tools.snackbar, () => {
      const msg = this.$store.state.tools.snackbar
      if (msg !== '') {
        if (msg.length >= 130) {
          this.multiLine = true
        } else {
          this.multiLine = false
        }
        this.show = true
        this.message = this.$store.state.tools.snackbar
        this.setSnackbar('')
      }
    })
  },

  methods: {
    ...mapActions({
      setSnackbar: 'tools/setSnackbar',
    }),
  },
}
</script>

<style lang="stylus">
.v-snack__content
  height auto !important
</style>



// WEBPACK FOOTER //
// src/components/utils/Snackbar.vue